//----------------
// Import frequently used Lodash methods here:
//----------------
import camelCase  from 'lodash/camelCase'
import capitalize from 'lodash/capitalize'
import cloneDeep  from 'lodash/cloneDeep'
import compact    from 'lodash/compact'
import filter     from 'lodash/filter'
import findKey    from 'lodash/findKey'
import isArray    from 'lodash/isArray'
import isEqual    from 'lodash/isEqual'
import isObject   from 'lodash/isObject'
import join       from 'lodash/join'
import omit       from 'lodash/omit'
import pick       from 'lodash/pick'
import reduce     from 'lodash/reduce'
import remove     from 'lodash/remove'
import snakeCase  from 'lodash/snakeCase'
import startCase  from 'lodash/startCase'
import toPairs    from 'lodash/toPairs'
import sum        from 'lodash/sum'
import sumBy      from 'lodash/sumBy'
import toUpper    from 'lodash/toUpper'
import transform  from 'lodash/transform'
import truncate   from 'lodash/truncate'
import groupBy    from 'lodash/groupBy'
import sortBy     from 'lodash/sortBy'
import each       from 'lodash/each'

function castToNumber(value) {
  if (value === '' || value === null || value === undefined) return null
  const num = Number(value)
  return Number.isNaN(num) ? null : num
}

const lodashMethods = {
  camelCase,
  capitalize,
  cloneDeep,
  compact,
  filter,
  findKey,
  isArray,
  isEqual,
  isObject,
  join,
  omit,
  pick,
  reduce,
  remove,
  snakeCase,
  startCase,
  sum,
  sumBy,
  toPairs,
  toUpper,
  transform,
  truncate,
  groupBy,
  sortBy,
  each,
}

//----------------
// Helper methods
//----------------
function pluralize(count, noun) {
  const suffix = 's'
  return `${count} ${noun}${count !== 1 ? suffix : ''}`
}

function camelizeKeysDeep(obj) {
  return transform(obj, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : camelCase(key);
    acc[camelKey] = isObject(value) ? camelizeKeysDeep(value) : value;
  })
}

function decamelizeKeysDeep(obj) {
  return transform(obj, (acc, value, key, target) => {
    const uncamelizedKey = isArray(target) ? key : snakeCase(key);
    acc[uncamelizedKey] = isObject(value) ? decamelizeKeysDeep(value) : value;
  })
}

const utils = {
  ...lodashMethods,
  camelizeKeysDeep,  
  decamelizeKeysDeep,
  castToNumber,
  pluralize
}

export default utils